module.exports = __webpack_public_path__ + "static/media/rise_doc2.8505526e.jpg";